var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchLoading',{staticClass:"loading-backgrounds py-0"})
}
var staticRenderFns = []

export { render, staticRenderFns }